module.exports = __webpack_public_path__ + "img/charger-camion.31de80d8.png";